import React, { useState } from "react";
import AddressList from "./component/AddressList";
import AddressForm from "./component/AddressForm";

const AddressManagement = ({ selectOnly = false, onSelectDeliveryAddress, onSelectBillingAddress }) => {
  const [editingAddress, setEditingAddress] = useState(null);
  const [addingAddress, setAddingAddress] = useState(false);
  const [refreshAddresses, setRefreshAddresses] = useState(false);

  const handleEdit = (address) => {
    setEditingAddress(address);
  };

  const handleAdd = () => {
    setAddingAddress(true);
  };

  const handleSave = (address) => {
    setEditingAddress(null);
    setAddingAddress(false);
    setRefreshAddresses(!refreshAddresses);
  };

  const handleCancel = () => {
    setEditingAddress(null);
    setAddingAddress(false);
  };

  return (
    <div>
      {(editingAddress || addingAddress) && <AddressForm address={editingAddress} onSave={handleSave} onCancel={handleCancel} />}
      <AddressList onEdit={handleEdit} onAdd={handleAdd} selectOnly={selectOnly} onSelectDeliveryAddress={onSelectDeliveryAddress} onSelectBillingAddress={onSelectBillingAddress} refreshAddresses={refreshAddresses} />
    </div>
  );
};

export default AddressManagement;
